module.exports = __webpack_public_path__ + "img/3-1.36c8f6f0.png";